import React, { Fragment } from "react";
import {
    Segment, Search, Radio, Button, Header, Accordion, Menu
} from 'semantic-ui-react';
import NoResultFound from "../noResultFound";
import { Constants } from "../../../config/appConstants";

const SelectTaskCodeComponent = props => {
    return (
        <>
            <Segment className="stickyHeader">
                <Header as="h3" size='medium' textAlign='center'> Select Taskcode </Header>
            </Segment>
            <Segment className="pb-2 root">
                {props.selectTaskCode.taskGrpList && props.selectTaskCode.taskGrpList.length > 0 &&
                    <div className="overflowScroll accordionMenuHeight">
                        <Accordion as={Menu} className="text m-0" vertical fluid>
                            {props.selectTaskCode.taskGrpList && props.selectTaskCode.taskGrpList.map(taskGrp => {
                                let isTaskGroupClicked = props.selectTaskCode.activeIndexForTaskGroup.some(taskGroupId => taskGroupId === taskGrp.groupID);
                                return (
                                    <Menu.Item className="m-0 no-padding">
                                        <Accordion.Title className="createTeam dropdownIconRight"
                                            active={isTaskGroupClicked}
                                            content={taskGrp.groupName}
                                            index={taskGrp.groupID}
                                            onClick={props.handleClickForTaskGrp}
                                        />
                                        <Accordion.Content className='no-padding' active={isTaskGroupClicked}>
                                            {taskGrp.groupData && taskGrp.groupData.length > 0 && taskGrp.groupData.map(task => {
                                                let isAllowTask = props.selectTaskCode.availableTaskList && props.selectTaskCode.availableTaskList.find(a => a.taskNumber === task.taskNumber && a.taskName === task.taskName);
                                                return (
                                                    <Radio className="selectedRow w-100 taskcodeSelected"
                                                        label={`${task.taskNumber} - ${task.taskName}`}
                                                        name='radioGroup'
                                                        value={task}
                                                        onClick={() => { isAllowTask && props.onSelectTaskCodeOption(task) }}
                                                        checked={isAllowTask && props.selectTaskCode && props.selectTaskCode.selectedTaskNumber === task.taskNumber && props.selectTaskCode.selectedTaskName === task.taskName}
                                                        disabled={!isAllowTask}

                                                    />
                                                )
                                            }
                                            )}
                                        </Accordion.Content>
                                    </Menu.Item>
                                )
                            })}
                        </Accordion>
                    </div>
                }
                {((props.selectTaskCode.taskCodeOptions && props.selectTaskCode.taskCodeOptions.length > 0) || (props.selectTaskCode.searchText !== "")) &&
                    <Search className='padding'
                        placeholder="Search Task Codes"
                        onSearchChange={props.onSearchTaskCodes}
                        value={props.selectTaskCode.searchText} />
                }
                {props.selectTaskCode.taskCodeOptions && props.selectTaskCode.taskCodeOptions.filter(t => t.taskNumber === props.selectTaskCode.selectedTaskNumber).map((taskCode) => (
                    <Radio className="selectedRow w-100 taskcodeSelected"
                        key={taskCode.id}
                        label={`${taskCode.taskNumber} - ${taskCode.taskName}`}
                        name='radioGroup'
                        value={taskCode.id}
                        onClick={() => { props.onSelectTaskCodeOption(taskCode) }}
                        checked={props.selectTaskCode && props.selectTaskCode.selectedTaskNumber === taskCode.taskNumber && props.selectTaskCode.selectedTaskName === taskCode.taskName}
                    />
                ))}
                <div className='mainContentRoot'>

                    {props.selectTaskCode.taskCodeOptions && props.selectTaskCode.taskCodeOptions.filter(t => t.taskNumber !== props.selectTaskCode.selectedTaskNumber).map((taskCode) => (
                        <Radio className="selectedRow w-100"
                            key={taskCode.id}
                            label={`${taskCode.taskNumber} - ${taskCode.taskName}`}
                            value={taskCode.id}
                            onChange={() => { props.onSelectTaskCodeOption(taskCode) }}
                            checked={props.selectTaskCode && props.selectTaskCode.selectedTaskNumber === taskCode.taskNumber && props.selectTaskCode.selectedTaskName === taskCode.taskName}
                        />
                    ))}

                    {(!props.selectTaskCode.taskCodeOptions || props.selectTaskCode.taskCodeOptions.length === 0) &&
                        <NoResultFound displayMessage={Constants.NO_TASKS_FOUND} />
                    }
                </div>
            </Segment>

            <Segment>
                <div className='d-flex justify-content-center btnFooter'>
                    <Button secondary className="borderRadius w-10"

                        size='small'
                        onClick={props.onClickBackButton}>
                        Back  </Button>
                </div>
            </Segment>
        </>
    );
}

export default SelectTaskCodeComponent;

SelectTaskCodeComponent.displayName = "SelectTaskCodeComponent";